import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const Loader: React.FC<{}> = () => {
  return <Container>
    <CircularProgress />
  </Container>;
};


export const ButtonLoader = styled(CircularProgress)`
  margin-right: 8px;
`;